(function ($) {
	"use strict";

	$(function () {
		const tabs = document.querySelectorAll(".js-tabs");
		const activeClass = "is-active";
		const animationClass = "is-visible";
		const slideDuration = 400;
		const accordionMq = window.matchMedia("(max-width: 743px)");

		function updateTheBar($trigger, $buttonList) {
			const currentColor = getComputedStyle($trigger[0]).getPropertyValue('--highlight').trim();
			const triggerWidth = $trigger.outerWidth();
			const triggerOffset = $trigger.parent().position().left - 6;

			$buttonList.css({ '--tab-highlight': currentColor, '--tab-width': triggerWidth + 'px', '--tab-offset': triggerOffset + 'px' });
		}

		tabs.forEach(tabSystem => {
			const $triggers = $('.js-tabs-trigger', $(tabSystem));
			const $bodies = $('.js-tabs-body', $(tabSystem));
			const $buttonList = $('.js-tabs-button-list', $(tabSystem));

			const triggerObserver = new ResizeObserver(entries => {
				entries.forEach(entry => {
					updateTheBar($triggers.filter(`.${activeClass}`), $buttonList);
				});
			});

			$triggers.each(function (index, trigger) {
				if (trigger.parentNode.classList.contains('tabs__header--lg')) {
					triggerObserver.observe(trigger);
				}
			});

			$triggers.on("click", function () {
				const $trigger = $(this);
				const loopNumber = $(this).data("loop-no");
				const uuid = $(this).data('uuid');
				const $bodyToOpen = $(`#tab-body-${uuid}-${loopNumber}`);
				const $triggersToOpen = $triggers.filter(function () {
					return $(this).data("loop-no") === loopNumber;
				});

				updateTheBar($trigger, $buttonList);

				$bodies.each(function () {
					if ($(this).hasClass(activeClass)) {
						if (accordionMq.matches) {
							$(this)
								.stop()
								.slideUp(slideDuration, function () {
									$(this).removeClass(activeClass);
									$(this).removeClass(animationClass);
									$(this).removeAttr("style");

									$([document.documentElement, document.body]).animate(
										{
											scrollTop: $trigger.offset().top - 80,
										},
										1000
									);
								});
						} else {
							$(this).removeClass(activeClass);
							$(this).removeClass(animationClass);
						}
					}
				});

				$triggers.each(function () {
					if ($(this).hasClass(activeClass)) {
						$(this).attr("aria-expanded", false);
						$(this).removeClass(activeClass);
					}
				});

				if (accordionMq.matches) {
					$bodyToOpen.stop().slideDown(slideDuration, function () {
						$(this).addClass(activeClass);

						setTimeout(() => {
							$(this).addClass(animationClass);
						}, 100);
					});
				} else {
					$bodyToOpen.addClass(activeClass);

					setTimeout(() => {
						$bodyToOpen.addClass(animationClass);
					}, 100);
				}

				$triggersToOpen.attr("aria-expanded", true).addClass(activeClass);
			});

			accordionMq.addEventListener("change", function () {
				if (!accordionMq.matches) {
					$bodies.removeAttr("style");
				}
			});

			$bodies.first().addClass('is-visible');
		});
	});
})(jQuery);
